module.exports = __webpack_public_path__ + "media/mkbg_2.857fe478.mp4";